import { Component, computed, inject, input } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { NodeCosam } from '@app/models/entity.model';
import { BreadcrumbComponent } from '@app/components/breadcrumb/breadcrumb.component';
import { ParagraphLoaderComponent } from '@app/entities/paragraph/loader.component';

import { HeroTextComponent } from '@app/components/hero-text/hero-text.component';
import { MediaComponent } from '@app/components/media/media.component';
import { RelatedContentComponent } from '@app/components/related-content/related-content.component';
import { ContentLinkService } from '@app/services/contentLinks.service';
import { ExtractUrlPipe } from '@app/pipes/extract-url.pipe';

@Component({
  selector: 'mobi-node-cosam',
  templateUrl: './node-cosam.component.html',
  styleUrls: ['./node-cosam.component.scss'],
  standalone: true,
  imports: [
    EntitySharedModule,
    BreadcrumbComponent,
    HeroTextComponent,
    MediaComponent,
    RelatedContentComponent,
    ParagraphLoaderComponent,
    ExtractUrlPipe,
  ],
})
export class NodeCosamComponent {
  readonly entity = input.required<NodeCosam>();

  #contentLink = inject(ContentLinkService);

  contentLinks = computed(() => {
    const paragraphs = this.entity()?.paragraphs;
    return this.#contentLink.getContentLinks(paragraphs);
  });
}
